import {
    ACTIVE_PARTNER_NAME, NEXT_INSURANCE_TERMS, LILI_BANKING_TERMS, LENDIO_TERMS
} from '../actions/accountSettingsActions';

export function accountSettingsReducer(prevState : any = {}, action : any = {}) {
    switch (action.type) {
        case 'EB_DASHBOARD':
            return {
                ...prevState,
                eb_dashboard: action.value
            };
        case 'MAGENTO':
            return {
                ...prevState,
                magento: action.value
            };
        case 'CUSTOMER_PORTAL':
            return {
                ...prevState,
                customer_portal: action.value
            };
        default:
            return prevState;
    }
}

export function activePartnerName(prevState: any = [], action: any = {}) {
    switch (action.type) {
        case ACTIVE_PARTNER_NAME:
            return action.value;
        default:
            return prevState;
    }
}

export function nextInsuranceTerms(prevState: any = [], action: any = []) {
    switch (action.type) {
        case NEXT_INSURANCE_TERMS:
            return action.value;
        default:
            return prevState;
    }
}

export function liliBankingTerms(prevState: any = [], action: any = []) {
    switch (action.type) {
        case LILI_BANKING_TERMS:
            return action.value;
        default:
            return prevState;
    }
}

export function lendioTerms(prevState: any = [], action: any = []) {
    switch (action.type) {
        case LENDIO_TERMS:
            return action.value;
        default:
            return prevState;
    }
}
